import React, {useState} from "react";

import Layout from "../components/Layout";

import ModalSuccess from '../components/ModalSuccess';
import ModalFail from '../components/ModalFail';

export default function Contact() {
    //Hooks
    const [isOpenSuccess, setIsOpenSuccess] = useState(false);
    const [isOpenFail, setIsOpenFail] = useState(false);


    const showModalSuccess = () => {
        setIsOpenSuccess(!isOpenSuccess);
    }

    const showModalFail = () => {
        setIsOpenFail(!isOpenFail);
    }

    const submitForm = (ev) => {
        ev.preventDefault();
        const form = ev.target;
        const data = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open(form.method, form.action);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 200) {
                form.reset();
                showModalSuccess();
            } else {
                showModalFail();
            }
        };
        xhr.send(data);
    }

    return (
        <Layout>
            <div id="main">
                <ModalSuccess show={isOpenSuccess}
                              onClose={showModalSuccess}/>
                <ModalFail show={isOpenFail}
                           onClose={showModalFail}/>
                <div className="contact_section_banner">
                    <div className="contact_banner">
                        <h1>Contact</h1>
                    </div>
                </div>
                <div className="inner">
                    <div className="services_section_1">
                        <h1 className="services_section_1__title" style={{fontWeight: 'bold'}}>We are here for you</h1>
                    </div>
                    <section className="card-contact">
                        <article>
                            <form onSubmit={submitForm} action="https://formspree.io/f/mknpvbzq" method="POST">
                                <input className="input-contact" type="text" name="name" placeholder="Name"
                                       id="name"
                                       required={true}/>
                                <input type="email" name="email" placeholder="Email" id="email" required={true}/>
                                <input type="tel" name="tel" placeholder="Telephone" id="tel" required={true}/>
                                <textarea name="message" placeholder="Message" id="message" rows="5"
                                          required={true}/>
                                <button type="submit">Send</button>
                            </form>
                        </article>
                        <article>
                            <div
                                style={{backgroundColor: '#ffffff', padding: 5, marginBottom: 10, textAlign: 'center'}}>
                                <dl style={{color: '#000000'}}>
<dd style={{margin: 0, textAlign: 'center', fontWeight: 'bold'}}>Tryon Technologies LLC</dd>
                                    <dd style={{margin: 0, textAlign: 'center'}}>16920 Kuykendahl Road Ste 228 Houston TX ,77068. USA
                                    </dd>
                                </dl>
                                <dl style={{margin: 0, color: '#000000'}}>
                                    <dd style={{margin: 0, textAlign: 'center'}}>admin@tyrion.tech</dd>
                                    <dd style={{margin: 0, textAlign: 'center'}}>+52 (55) 5344-6775</dd>
                                    <dd style={{margin: 0, textAlign: 'center'}}>Horario 9:00–18:00 HRS</dd>
                                </dl>
                            </div>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.5341762067965!2d-95.47783671622938!3d30.02152931030716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640cb60b1dc7a33%3A0xbe75642f6dbd2e68!2s16920%20Kuykendahl%20Rd%2C%20Houston%2C%20TX%2077068%2C%20EE.%20UU.!5e0!3m2!1ses-419!2smx!4v1725590550958!5m2!1ses-419!2smx"
                                className={{border: 0}}
                                width="100%" height="50%" frameBorder="0" allowFullScreen=""
                                aria-hidden="false" tabIndex="0">
                            </iframe>
                        </article>
                    </section>
                </div>
            </div>
        </Layout>
    )
}
